/* ================= KONNI39 - CHUAN HOA CHUOI / NGAY =================
   Tach nguyen ven tu app/KONNI39-xu-ly-don-hang_v4.html (khoi window.KONNI).
   Khong phu thuoc DOM.
==================================================================== */

/* ---------- chuan hoa chuoi ---------- */
export function norm(v) {
  if (v === null || v === undefined) return '';
  if (typeof v === 'number') {
    if (Number.isInteger(v)) return String(v);
    return String(v);
  }
  return String(v).normalize('NFC').replace(/ /g, ' ').trim();
}
export function normKey(v) {
  return norm(v).toLowerCase().replace(/\s+/g, ' ');
}
export function toInt(v) {
  var s = norm(v).replace(/[^\d\-]/g, '');
  var n = parseInt(s, 10);
  return isNaN(n) ? 0 : n;
}

/* ---------- ngay thang: doc raw serial, quy doi bang UTC ---------- */
export function excelSerialToText(n) {
  var ms = Math.round((n - 25569) * 86400 * 1000);
  var d = new Date(ms);
  if (isNaN(d.getTime())) return '';
  var p = function (x) { return String(x).padStart(2, '0'); };
  return d.getUTCFullYear() + '-' + p(d.getUTCMonth() + 1) + '-' + p(d.getUTCDate()) +
    ' ' + p(d.getUTCHours()) + ':' + p(d.getUTCMinutes());
}
export function dateText(v) {
  if (v === null || v === undefined || v === '') return '';
  if (typeof v === 'number') return excelSerialToText(v);
  var s = norm(v);
  // TikTok: 31/07/2026 10:17:17
  var m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})[ T]?(\d{1,2}:\d{2})?/);
  if (m) {
    return m[3] + '-' + String(m[2]).padStart(2, '0') + '-' + String(m[1]).padStart(2, '0') +
      (m[4] ? ' ' + m[4] : '');
  }
  return s;
}

/* "2026-09-09 10:17" | ISO -> epoch ms; NaN neu rong/hong */
export function dayMs(v) {
  if (!v) return NaN;
  var d = new Date(String(v).replace(' ', 'T'));
  return d.getTime();
}
